import { colors, fonts } from 'components/styles/variables';

interface ButtonProps {
  children: JSX.Element | string;
  onClick: () => void;
  className?: string;
}

function Button({ children, onClick, className }: ButtonProps): JSX.Element {
  return (
    <>
      <button className={`onboarding-button ${className}`} onClick={onClick}>
        {children}
      </button>
      <style jsx>{`
        .onboarding-button {
          width: 295px;
          height: 48px;
          text-align: center;
          border-radius: 8px;
          font-family: ${fonts.default};
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.2px;
          padding: 0 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          color: ${colors.WHITE};
          border: none;
          background-color: ${colors.ALR1};
        }
      `}</style>
    </>
  );
}

export default Button;
